"use client"

import { MapPinned } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MapPinnedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MapPinnedIcon = component(Icon)({ as: MapPinned })
